export default __webpack_public_path__ + "static/media/homeimg.6ef27525.png";